export  const  BASE_URL = 'https://api.gadgetzippy.com/';
export const IMG_URL = 'https://api.vasu.life/assets/'; 
